import { TeamTranslate } from './teamTranslate.model';

const teamTranslateEN: TeamTranslate = {
  page: {
    title: 'Team',
    subtitle: 'Manage who has access to this studio.',
  },
  inviteCta: 'Invite member',
  members: {
    title: 'Members',
    emptyState: 'No team members yet.',
    ownerBadge: 'Owner',
    youBadge: 'You',
  },
  pendingInvitations: {
    title: 'Pending invitations',
    emptyState: 'No pending invitations.',
    expiresAt_one: 'Expires in 1 day',
    expiresAt_other: 'Expires in {{count}} days',
    expiredLabel: 'Expired',
  },
  inviteModal: {
    title: 'Invite member',
    emailLabel: 'Email',
    roleLabel: 'Role',
    cta: 'Send invitation',
    success: 'Invitation created!',
    successHint:
      'We emailed the invitation when available; you can also copy the link below. They have 7 days to accept.',
    copyCta: 'Copy link',
    copied: 'Copied',
    closeCta: 'Close',
    emailRequired: 'Email is required.',
    emailInvalid: 'Please enter a valid email.',
    roleRequired: 'Pick a role for the new member.',
  },
  roles: {
    administrator: 'Administrator',
    manager: 'Manager',
    member: 'Member',
  },
  actions: {
    changeRole: 'Change role',
    remove: 'Remove from team',
    transferOwnership: 'Transfer ownership',
    cancelInvitation: 'Cancel invitation',
    resendInvitation: 'Resend invitation',
    resetPassword: 'Reset password',
    memberActions: 'Member actions',
  },
  confirmRemove: {
    title: 'Remove member',
    message:
      'This person will lose access to the studio immediately. You can invite them again later.',
    confirmCta: 'Remove',
    cancelCta: 'Cancel',
  },
  confirmTransfer: {
    title: 'Transfer ownership',
    message:
      'You will stay an administrator, but this person becomes the new studio owner. Continue?',
    confirmCta: 'Transfer',
    cancelCta: 'Cancel',
  },
  confirmResetPassword: {
    title: 'Reset password',
    message:
      'This will email the person a link to set a new password. Continue?',
    confirmCta: 'Reset password',
    cancelCta: 'Cancel',
  },
  toasts: {
    inviteSuccess: 'Invitation sent successfully.',
    inviteError: "Couldn't create the invitation. Please try again.",
    cancelInvitationSuccess: 'Invitation canceled.',
    cancelInvitationError: "Couldn't cancel the invitation. Please try again.",
    resendSuccess: 'Invitation resent with a new link.',
    removeMemberSuccess: 'Member removed from the team.',
    removeMemberError: "Couldn't remove the member. Please try again.",
    changeRoleSuccess: 'Member role updated.',
    changeRoleError: "Couldn't change the member role. Please try again.",
    transferOwnershipSuccess: 'Ownership transferred successfully.',
    transferOwnershipError: "Couldn't transfer ownership. Please try again.",
    resetPasswordSuccess: 'Password reset email sent.',
    linkCopied: 'Invitation link copied to clipboard.',
    linkCopyError: "Couldn't copy the link. Please copy it manually.",
  },
  acceptPage: {
    states: {
      loading: 'Loading invitation...',
      invalid: {
        title: 'Invalid invitation',
        message: 'This link is not valid.',
        backCta: 'Back to login',
      },
      expired: {
        title: 'Invitation expired',
        message:
          'This invitation has expired. Ask the studio administrator for a new one.',
        backCta: 'Back to login',
      },
      canceled: {
        title: 'Invitation canceled',
        message: 'This invitation was canceled by the studio administrator.',
        backCta: 'Back to login',
      },
      accepted: {
        title: 'Invitation already accepted',
        message: 'This invitation has already been accepted.',
        goAppCta: 'Go to app',
      },
      notLogged: {
        title: 'Accept invitation',
        message:
          'Create your account or sign in with {{email}} to accept the invitation. Use that exact email.',
        signupCta: 'Create account',
        loginCta: 'I already have an account',
      },
      emailMismatch: {
        title: 'Email mismatch',
        message:
          'This invitation was sent to a different email. Sign out and sign in with the correct account.',
        logoutCta: 'Sign out',
      },
      ready: {
        title: 'Accept invitation to {{tenantName}}',
        message: 'You have been invited to {{tenantName}} as {{role}}.',
        acceptCta: 'Accept invitation',
      },
    },
    toasts: {
      acceptSuccess: 'Invitation accepted!',
      acceptError: 'Could not accept the invitation. Please try again.',
    },
  },
};

export default teamTranslateEN;
